import { ColumnState } from '@ag-grid-community/core';

import { ViewSortModel, NoNullField } from './datacenter-aggrid-view';
import {
	WEIGHT_OPTIONS,
	PRODUCT_OPTIONS,
	ORDER_NUMBER_OPTIONS,
	ORDER_TRACKING_LIST_SORT,
	SURVEY_SCREEN_NAME_OPTIONS,
	DOWNLOAD_OPTIONS,
} from './list';

export const CUSTOMER = 'customer';
export const ARTICLE = 'article';
export const GROSS = 'gross';
export const AGGREGATED = 'aggregated';
export const ORDER_SORT = 'customerOrderNumber';

export const ORDER = 'order';
export const PRODUCT = 'product';
export const CDD = 'cddWeek';
export const ORDER_TRACKING_SORT_LIST = 'ordertrackingsortlist';

interface ProductSetting {
	key: 'product';
	value: {
		version: 1;
		product: keyof typeof PRODUCT_OPTIONS;
	};
}

interface OrderSetting {
	key: 'order';
	value: {
		version: 1;
		order: keyof typeof ORDER_NUMBER_OPTIONS;
	};
}

interface OrderTrackingSortListSetting {
	key: 'ordertrackingsortlist';
	value: {
		version: 1;
		ordertrackingsortlist: keyof typeof ORDER_TRACKING_LIST_SORT;
	};
}

interface WeightSetting {
	key: 'weight';
	value: {
		version: 1;
		weight: keyof typeof WEIGHT_OPTIONS;
	};
}

interface DownloadSetting {
	key: 'download';
	value: {
		version: 1;
		type: keyof typeof DOWNLOAD_OPTIONS;
	};
}

interface InternalSetting {
	key: 'internal';
	value: {
		version: 1;
		customers: CustomerInterface[];
	};
}

interface CurrentCustomerSetting {
	key: 'current_customer';
	value: {
		version: 1;
		customer: CustomerInterface;
	};
}

interface LastBatchListSetting {
	key: 'last_batches';
	value: {
		version: 1;
		batchesVgId: Record<number, string[] | undefined>;
	};
}

interface ScanSetting {
	key: 'scan';
	value: {
		version: 1;
		scanMode: 'laser' | 'matrix';
		beep: boolean;
		displayTip: boolean;
	};
}

interface OfferHeader {
	key: 'offer_header';
	value: {
		version: 1;
		offerHeader: OfferHeaderContent;
	};
}

export interface OfferHeaderContent {
	soldTo: string;
	shipTo: string;
	endUser: string;
	idd: string;
	tmode: string;
	incot: string;
	pricingUnit: string;
	currency: string;
}

export interface OfferAdyco {
	key: 'offer_adyco';
	value: {
		version: 1;
		offerAdyco: [
			{
				soldTo: string;
				familyCode: string;
				selectedCharacteristics: string[];
				isToggle: boolean | undefined;
			}
		];
	};
}

export interface View {
	columnState: (NoNullField<ColumnState> & { colId: string; groupId?: string | undefined })[];
	sortModel?: ViewSortModel[] | null | undefined;
}

export interface CustomizedViewSetting {
	key: string;
	value: View;
}

interface SurveySetting {
	key: 'survey';
	value: {
		version: 1;
		page: keyof typeof SURVEY_SCREEN_NAME_OPTIONS;
		isAnswered?: true | false;
	};
}

interface FastLaneMain {
	key: 'fastlane_main';
	value: {
		version: 1;
		fastLaneMainContent: FastLaneMainContent;
	};
}

export interface FastLaneMainContent {
	currency: string;
	soldTo: string;
}

export type SettingsType =
	ProductSetting
	| OrderSetting
	| WeightSetting
	| DownloadSetting
	| InternalSetting
	| CurrentCustomerSetting
	| OrderTrackingSortListSetting
	| LastBatchListSetting
	| ScanSetting
	| OfferHeader
	| OfferAdyco
	| SurveySetting
	| FastLaneMain
	| CustomizedViewSetting;

interface CustomerInterface {
	vgid: number;
	membername: string;
}

export interface UserSettingsInterface {
	key: string;
	value: string;
}
